import './App.css';
import React from 'react';

import DefaultRoute from "./core/components/ErrorPage";
import TargetedRoute from "./routes/TargetedRoute";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

library.add(faExclamationTriangle);

function App() {
  const path = window.location.pathname;
  const host = window.location.host;
  const subdomain = host.split(".")[0];

  // NOTE: don't mutate window.location directly inside render;
  // use Redirect routes below.

  const TrailingSlashNormalizer = () => {
    // only normalize when there's a trailing slash and it's not just "/"
    if (path.length > 1 && /\/$/.test(path)) {
      return <Redirect to={path.replace(/\/+$/, '') + window.location.search + window.location.hash} />;
    }
    return null;
  };

  const FileRedirect = () => {
    // Redirect for all files hosted at sites.thecollege.asu.edu
    if (path.includes("/sites/default/files/")) {
      const fileTarget = path.split("/sites/default/files/")[1];
      return <Redirect to={`https://sites.thecollege.asu.edu/sites/default/files/${fileTarget}`} />;
    }
    return null;
  };

  const isDefaultSite =
    subdomain === "faculty" ||
    subdomain === "lab" ||
    subdomain.split(":")[0] === "localhost";

  if (isDefaultSite) {
    // Default sites: "/", "/:group", "/:group/anything"
    return (
      <Router>
        <TrailingSlashNormalizer />
        <FileRedirect />
        <Switch>
          {/* Deep pages under a group MUST come first and NOT be exact */}
          <Route
            path="/:group/:rest(.*)"
            render={(props) => <TargetedRoute {...props} custom={false} />}
          />
          {/* Exactly the group root */}
          <Route
            exact
            path="/:group"
            render={(props) => <TargetedRoute {...props} custom={false} />}
          />
          {/* Site root */}
          <Route
            exact
            path="/"
            render={(props) => <TargetedRoute {...props} custom={false} />}
          />
          {/* 404 */}
          <Route component={DefaultRoute} />
        </Switch>
      </Router>
    );
  } else {
    // Custom sites: everything maps to TargetedRoute with group=subdomain
    return (
      <Router>
        <TrailingSlashNormalizer />
        <FileRedirect />
        <Switch>
          {/* Catch-all for custom sites — DO NOT use exact here */}
          <Route
            path="/"
            render={(props) => (
              <TargetedRoute
                {...props}
                page={props.location.pathname}
                group={subdomain}
                custom={true}
              />
            )}
          />
          {/* (Optional) a 404 after this would never run because of the catch-all above */}
        </Switch>
      </Router>
    );
  }
}

export default App;